module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qrepr4-576d3100cc100136776d3a13882faec8.jpg";